import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Modal, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../features/save/saveSlice";
import { fetchOrganization } from "../../../features/dropdown/dropdownSlice";
import PhoneInput from "react-phone-input-2";

const CreateNdovuWalletModal = ({ open, handleFetchData, handleCancel }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { organization } = useSelector((state) => state.dropdown);
  const { saving } = useSelector((state) => state.save);

  const [formData, setFormData] = useState();

  const onChangeOther = (value, fieldName) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const onFinish = async (data) => {
    data.usrEncryptedPassword = "1234";
    data.orgCertificateOfIncorporation = null
    const res = await dispatch(
      save({
        ...data,
        url: "py/createNdovupayWallet.action",
      })
    );
    console.log("res?.payload",res?.payload)
    if (res?.payload?.success) {
      await toast.success(res?.payload?.jsonData?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.jsonData?.messages?.message);
    }
  };
 
  return (
    <>
      <Modal
        className=""
        title="Create Ndovupay Wallet"
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={800}
        maskClosable={false}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className="px-[15px]"
          style={{
            maxWidth: "100%",
          }}
          form={form}
          initialValues={organization}
        >
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-2">
            <Form.Item
              name="orgCounty"
              label="Country"
              className="login-form-item "
              rules={[
                {
                  required: true,
                  message: "Please add country",
                },
              ]}
            >
              <Input className="input" />
            </Form.Item>

            <Form.Item
              name="orgName"
              label="Name"
              className="login-form-item "
              rules={[
                {
                  required: true,
                  message: "Please add organization name",
                },
              ]}
            >
              <Input className="input" />
            </Form.Item>

            <Form.Item
              name="orgEmail"
              label="Email"
              className="login-form-item "
              rules={[
                {
                  required: true,
                  message: "Please add organization name",
                },
                {
                  type: "email",
                  message: "Please enter a valid email address",
                },
              ]}
            >
              <Input type="email" className="input" />
            </Form.Item>

            <Form.Item
              className="table-form-item"
              name="orgMobile"
              label="Mobile No"
              rules={[
                {
                  required: true,
                  message: "Please add mobile no",
                },
                {
                  validator: (_, value) => {
                    if (value && value.length === 12) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Phone number must be exactly 10 characters")
                    );
                  },
                },
              ]}
            >
              <PhoneInput
                country="ke"
                countryCodeEditable={false}
                className="input"
              />
            </Form.Item>

            <Form.Item
              className="table-form-item"
              name="orgKraPin"
              label="KRA Pin"
              rules={[
                {
                  required: true,
                  message: "Please add KRA pin",
                },
                {
                  pattern: /^[A-Z0-9]{11}$/,
                  message:
                    "Invalid Kra Pin format. A valid Kra Pin should be 11 alphanumeric characters.",
                },
              ]}
            >
              <Input className="input" />
            </Form.Item>

            <Form.Item
              name="orgLocation"
              label="Location"
              className="login-form-item "
              rules={[
                {
                  required: true,
                  message: "Please add location",
                },
              ]}
            >
              <Input className="input" />
            </Form.Item>

            <Form.Item
              name="orgTown"
              label="Town"
              className="login-form-item "
              rules={[
                {
                  required: true,
                  message: "Please add Town",
                },
              ]}
            >
              <Input className="input" />
            </Form.Item>

            <Form.Item
              name="usrFirstName"
              label="First Name"
              className="login-form-item "
              rules={[
                {
                  required: true,
                  message: "Please add First Name",
                },
              ]}
            >
              <Input className="input" />
            </Form.Item>

            <Form.Item
              name="usrLastName"
              label="Last Name"
              className="login-form-item "
              rules={[
                {
                  required: true,
                  message: "Please add Last Name",
                },
              ]}
            >
              <Input className="input" />
            </Form.Item>

            <Form.Item
              name="usrEmail"
              label="Email"
              className="login-form-item "
              rules={[
                {
                  required: true,
                  message: "Please add user email",
                },
                {
                  type: "email",
                  message: "Please enter a valid email address",
                },
              ]}
            >
              <Input type="email" className="input" />
            </Form.Item>

            <Form.Item
              className="table-form-item"
              name="usrMobileNumber"
              label="User Mobile No"
              rules={[
                {
                  required: true,
                  message: "Please add user mobile no",
                },
                {
                  validator: (_, value) => {
                    if (value && value.length === 12) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Phone number must be exactly 10 characters")
                    );
                  },
                },
              ]}
            >
              <PhoneInput
                country="ke"
                countryCodeEditable={false}
                className="input"
              />
            </Form.Item>
          </div>

          <div className="flex justify-between mt-[48px] ">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center mb-[58px] gap-x-5">
              <div className="w-[150px] ">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[150px]">
                <button key="submit" type="submit" className="cstm-btn">
                  {saving ? <Spin /> : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default CreateNdovuWalletModal;
